import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Linklist } from '@ktag/styleguide/dist/react';
import ToolDialogSubtitle from '../../components/tooldialog/ToolDialogSubtitle';
import Scrollable from '../../components/scrollable/Scrollable';
import useAppState from '../../AppStore';

const PrintedList = () => {
  const { t } = useTranslation('agisviewer');
  const printedItems = useAppState((state) => state.printedItems);
  const cleanPrintedItem = useAppState((state) => state.cleanPrintedItem);
  const showPrintedItems = useAppState((state) => state.showPrintedItems);
  const toggleShowPrintedItems = useAppState((state) => state.toggleShowPrintedItems);

  useEffect(() => {
    const interval = setInterval(() => {
      cleanPrintedItem();
    }, 60000);

    return () => clearInterval(interval);
  }, [cleanPrintedItem]);

  if (!printedItems.length) return null;

  const links = printedItems.map((item) => ({
    icon: { id: item.icon },
    linkText: item.label,
    target: {
      external: true,
      url: item.url,
    },
  }));

  return (
    <>
      <div
        className={classNames('tooldialog__wrapper-content printed-list__header', {
          'printed-list__header--close': !showPrintedItems,
        })}
      >
        <ToolDialogSubtitle
          title={t('last_printed_items')}
          icon={`chevron-${showPrintedItems ? 'up' : 'down'}`}
          onClick={toggleShowPrintedItems}
        />
      </div>

      {showPrintedItems &&
        (links.length === 0 ? (
          <div className="tooldialog__wrapper-content printed-list__content">
            {t('no_printed_items')}
          </div>
        ) : (
          <Scrollable additionalClassName="tooldialog__wrapper-content printed-list__content">
            <Linklist links={links.reverse()} additionalClassNames="printed-link__list" />
          </Scrollable>
        ))}
    </>
  );
};

export default PrintedList;
